// Configuration for exam prep topics organized by state and year level
// Keys match S3 path structure (e.g., '11_standard' -> nsw/11_standard/nsw_11_standard.json)
export const examPrepConfig = {
  NSW: {
    '7': {
      displayName: 'Year 7',
      topics: [
        'Whole Numbers',
        'Fractions and Decimals',
        'Percentages',
        'Algebra - Introduction',
        'Patterns and Relationships',
        'Angles and Lines',
        'Area and Perimeter',
        'Data and Graphs',
        'Probability - Introduction'
      ]
    },
    '8': {
      displayName: 'Year 8',
      topics: [
        'Integers',
        'Fractions, Decimals and Percentages',
        'Ratio and Proportion',
        'Algebra - Linear Expressions',
        'Linear Equations',
        'Geometry - Properties',
        'Measurement',
        'Statistics',
        'Probability'
      ]
    },
    '9': {
      displayName: 'Year 9',
      topics: [
        'Surds and Indices',
        'Linear Relationships',
        'Non-linear Relationships',
        'Right-angled Triangles',
        'Measurement and Geometry',
        'Statistics and Probability',
        'Financial Mathematics'
      ]
    },
    '10': {
      displayName: 'Year 10',
      topics: [
        'Algebra',
        'Functions and Graphs',
        'Trigonometry',
        'Probability',
        'Statistics',
        'Financial Mathematics',
        'Measurement'
      ]
    },
    '11_standard': {
      displayName: 'Year 11 Standard',
      topics: [
        "Formulae & Equations",
        "Linear Relationships",
        "Applications of Measurement",
        "Working with Time",
        "Money Matters",
        "Data Analysis",
        "Relative Frequency & Probability"
      ]
    },
    '11_advanced': {
      displayName: 'Year 11 Advanced',
      topics: [
        "Working with Functions",
        "Trigonometry & Angle Measure",
        "Trigonometric Functions & Identities",
        "Introductory Differentiation",
        "Exponentials & Logarithms",
        "Probability & Discrete Distributions"
      ]
    },
    '12_standard': {
      displayName: 'Year 12 Standard',
      topics: [
        'Algebra',
        'Measurement',
        'Financial Mathematics',
        'Statistical Analysis',
        'Networks and Decision Mathematics'
      ]
    },
    '12_advanced': {
      displayName: 'Year 12 Advanced',
      topics: [
        'Functions',
        'Trigonometric Functions',
        'Calculus',
        'Exponential and Logarithmic Functions',
        'Combinatorics',
        'Series and Sequences',
        'Statistics'
      ]
    }
  },
  VIC: {
    '7': {
      displayName: 'Year 7',
      topics: [
        'Number and Algebra',
        'Measurement and Geometry',
        'Statistics and Probability'
      ]
    },
    '8': {
      displayName: 'Year 8',
      topics: [
        'Number and Algebra',
        'Measurement and Geometry',
        'Statistics and Probability'
      ]
    },
    '9': {
      displayName: 'Year 9',
      topics: [
        'Number and Algebra',
        'Measurement and Geometry',
        'Statistics and Probability'
      ]
    },
    '10': {
      displayName: 'Year 10',
      topics: [
        'Number and Algebra',
        'Measurement and Geometry',
        'Statistics and Probability'
      ]
    },
    '11_general': {
      displayName: 'Year 11 General',
      topics: [
        'Algebra and Structure',
        'Arithmetic and Number',
        'Discrete Mathematics',
        'Geometry, Measurement and Trigonometry',
        'Graphs of Linear and Non-linear Relations',
        'Statistics'
      ]
    },
    '11_methods': {
      displayName: 'Year 11 Methods',
      topics: [
        'Functions and Graphs',
        'Algebra',
        'Calculus',
        'Probability and Statistics'
      ]
    },
    '12_general': {
      displayName: 'Year 12 General',
      topics: [
        'Algebra and Structure',
        'Arithmetic and Number',
        'Discrete Mathematics',
        'Geometry, Measurement and Trigonometry',
        'Graphs of Linear and Non-linear Relations',
        'Statistics'
      ]
    },
    '12_methods': {
      displayName: 'Year 12 Methods',
      topics: [
        'Functions and Graphs',
        'Algebra',
        'Calculus',
        'Probability and Statistics'
      ]
    }
  },
  QLD: {
    '7': {
      displayName: 'Year 7',
      topics: [
        'Number and Place Value',
        'Fractions and Decimals',
        'Money and Financial Mathematics',
        'Patterns and Algebra',
        'Using Units of Measurement',
        'Geometric Reasoning',
        'Location and Transformation',
        'Chance',
        'Data Representation and Interpretation'
      ]
    },
    '8': {
      displayName: 'Year 8',
      topics: [
        'Real Numbers',
        'Money and Financial Mathematics',
        'Patterns and Algebra',
        'Linear and Non-linear Relationships',
        'Using Units of Measurement',
        'Geometric Reasoning',
        'Location and Transformation',
        'Chance',
        'Data Representation and Interpretation'
      ]
    },
    '9': {
      displayName: 'Year 9',
      topics: [
        'Real Numbers',
        'Money and Financial Mathematics',
        'Patterns and Algebra',
        'Linear and Non-linear Relationships',
        'Using Units of Measurement',
        'Pythagoras and Trigonometry',
        'Geometric Reasoning',
        'Chance',
        'Data Representation and Interpretation'
      ]
    },
    '10': {
      displayName: 'Year 10',
      topics: [
        'Real Numbers',
        'Money and Financial Mathematics',
        'Patterns and Algebra',
        'Linear and Non-linear Relationships',
        'Using Units of Measurement',
        'Pythagoras and Trigonometry',
        'Geometric Reasoning',
        'Chance',
        'Data Representation and Interpretation'
      ]
    },
    '11_general': {
      displayName: 'Year 11 General',
      topics: [
        'Money and Financial Mathematics',
        'Geometry and Trigonometry',
        'Graphs and Networks',
        'Statistics'
      ]
    },
    '11_methods': {
      displayName: 'Year 11 Methods',
      topics: [
        'Algebra and Functions',
        'Calculus and Further Functions',
        'Statistics'
      ]
    },
    '12_general': {
      displayName: 'Year 12 General',
      topics: [
        'Money and Financial Mathematics',
        'Geometry and Trigonometry',
        'Graphs and Networks',
        'Statistics'
      ]
    },
    '12_methods': {
      displayName: 'Year 12 Methods',
      topics: [
        'Algebra and Functions',
        'Calculus and Further Functions',
        'Statistics'
      ]
    }
  }
};

// Helper function to get available year levels for a state (returns S3-compatible keys)
export const getYearLevelsForState = (state) => {
  return Object.keys(examPrepConfig[state] || {});
};

// Helper function to get display name for a year level key
export const getDisplayNameForYearLevel = (state, yearLevelKey) => {
  return examPrepConfig[state]?.[yearLevelKey]?.displayName || yearLevelKey;
};

// Helper function to get year level key from display name (for backward compatibility)
export const getYearLevelKeyFromDisplayName = (state, displayName) => {
  const stateConfig = examPrepConfig[state];
  if (!stateConfig) return null;
  
  for (const [key, config] of Object.entries(stateConfig)) {
    if (config.displayName === displayName) {
      return key;
    }
  }
  return null;
};

// Helper function to get topics for a specific state and year level
export const getTopicsForStateAndYear = (state, yearLevel) => {
  return examPrepConfig[state]?.[yearLevel]?.topics || [];
};

// Helper function to get all available states
export const getAvailableStates = () => {
  return Object.keys(examPrepConfig);
};
